import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
export const initI18n = (defaultLocale) =>  {
    return new VueI18n({
        locale: defaultLocale || 'en',
        fallbackLocale: 'en',
        messages: {
            en: require('./langDicts/en').en,
            [defaultLocale]: require(`./langDicts/${defaultLocale}`)['default'],
        }
    })
}